
    import { DateTime } from 'luxon'
    import { computed, defineComponent, onBeforeMount } from 'vue'
    import { useI18n } from 'vue-i18n-composable'
    import { useRouter } from 'vue-router/composables'

    import PostPreviewList from '@/app/components/common/posts/PostPreviewList.vue'
    import { useBreadcrumbsStore } from '@/app/stores/breadcrumbs'
    import { usePostsStore } from '@/app/stores/posts'

    import { useHeadful } from '@/common/composables/libs/headful'

    export default defineComponent({
        components: {
            PostPreviewList
        },
        props: {
            date: {
                type: Date,
                required: true
            },
            page: {
                type: Number,
                default: 1
            }
        },
        setup (props) {
            const headful = useHeadful()
            const i18n = useI18n()
            const router = useRouter()
            const postsStore = usePostsStore()

            const data = computed(() => postsStore.byDate(props.date))
            const entries = computed(() => data.value.data)
            const paginationMeta = computed(() => data.value.meta)
            const formattedDate = computed(() => DateTime.fromJSDate(props.date).toLocaleString(DateTime.DATE_FULL))

            const paginate = async (page: number): Promise<void> => {
                await router.push({
                    name: 'posts.by-date',
                    params: {
                        page: page.toString(),
                        date: DateTime.fromJSDate(props.date).toFormat('yyyy-MM-dd')
                    }
                })

                await postsStore.loadByDate({
                    date: props.date,
                    page: page
                })
            }

            onBeforeMount(async (): Promise<void> => {
                useBreadcrumbsStore().set([
                    { text: i18n.t('nav.breadcrumbs.posts') as string },
                    { text: i18n.t('nav.breadcrumbs.calendar') as string, to: { name: 'posts.dates' } },
                    { text: formattedDate.value }
                ])

                headful({
                    title: `${i18n.t('nav.breadcrumbs.posts-from-day')} ${formattedDate.value} | ${i18n.t('meta.title')}`
                })

                await postsStore.loadByDate({
                    date: props.date,
                    page: props.page
                })

                if (paginationMeta.value.total === 0) {
                    await router.replace({
                        name: 'posts.dates'
                    })
                }
            })

            return {
                entries,
                formattedDate,
                paginationMeta,
                paginate
            }
        }
    })
